<template>
  <main class="login container">
    <div class="row">
      <div class="col-12 col-6-tablet push-3-tablet text-center">
        <h1 class="font-100">Connexion sur l'éditeur John Steel</h1>
      </div>
    </div>
    <div class="row">
      <div
        class="col-12 col-6-tablet push-3-tablet col-4-desktop push-4-desktop"
      >
        <b-alert v-if="error"
            show
            dismissible
            fade
            variant="warning">
            {{ error }}
        </b-alert>

        <form
          class="form"
          method="post"
          @submit.prevent="onSubmit(email, password)"
        >
          <fieldset>
            <input
              v-model="email"
              class="block"
              type="email"
              name="email"
              :placeholder="$t('login.email')"
            />
          </fieldset>

          <fieldset>
            <input
              v-model="password"
              class="block"
              type="password"
              name="password"
              :placeholder="$t('login.password')"
            />
          </fieldset>

          <button type="submit" class="button button-primary block login">
            <t login.login />
          </button>
        </form>
      </div>
    </div>
  </main>
</template>

<script>

import { BAlert } from 'bootstrap-vue'

export default {
    components: {
        BAlert
    },
    name: 'Login',
    data() {
        return {
            email: null,
            password: null,
            error: null
        }
    },
    methods: {
        async onSubmit(email, password) {
            try {
                await this.$store.dispatch('auth/authenticate', { strategy: 'local', email, password });
                this.$router.push({name:"compositions"});
            }
            catch(err) {
                this.error = err.className === "not-authenticated"
                    ? 'E-mail ou mot de passe incorrect.'
                    : 'Une erreur a empêché la connexion.'
                ;
                this.$store.dispatch('setEditorError', err);
            }
        }
    }
}
</script>
